export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.use-management': 'Vehicle Use',
  'menu.use-management.requests': 'Usage Requests',
  'menu.use-management.calendar': 'Usage Calendar',
  'menu.use-management.tasks': 'Usage Tasks',
  'menu.use-management.use-records': 'Usage Records',
  'menu.use-management.driver': 'Driver Workspace',
  'menu.driver-management': 'Driver Management',
  'menu.driver-management.driver-profiles': 'Driver Profiles',
  'menu.driver-management.driver-licenses': 'Driver Licenses',
  'menu.vehicle-management': 'Vehicle Management',
  'menu.vehicle-management.vehicle-records': 'Vehicle Records',
  'menu.vehicle-management.vehicle-status': 'Vehicle Status',
  'menu.vehicle-management.vehicle-dispatch': 'Dispatch Center',
  'menu.vehicle-management.vehicle-certificates': 'Vehicle Certificates',
  'menu.vehicle-management.vehicle-lifecycle': 'Vehicle Lifecycle',
  'menu.data-analysis': 'Data Analysis',
  'menu.data-analysis.analytics': 'Vehicle Analytics',
  'menu.system-management': 'System Management',
  'menu.system-management.logs': 'Operation Logs',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings': 'System Settings',
  'menu.settings.permissions': 'Permission Management',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
